import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchPaymentProfiles, deletePaymentProfile } from '../services/PaymentProfilesService';

export const usePaymentProfiles = () => {
    const queryClient = useQueryClient();

    const paymentProfilesQuery = useQuery({
        queryKey: ['payment-profiles'],
        queryFn: () => fetchPaymentProfiles()
    });

    const deleteMutation = useMutation({
        mutationFn: deletePaymentProfile,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['payment-profiles'] });
        }
    });

    return {
        paymentProfiles: paymentProfilesQuery.data || [],
        loading: paymentProfilesQuery.isLoading,
        error: paymentProfilesQuery.error,
        deletePaymentProfile: deleteMutation.mutate,
        isDeleting: deleteMutation.isPending
    };
};
